import * as React from 'react';
import PropTypes from 'prop-types';
import { useAppSelector } from '../../../../app/store';
import TruckIcon from "../../../../assets/icons/TruckIcon";
import style from "./style.module.css";
import reducerPath from '../../../../app/reducerPath';

function VehicleStatuses({ ids, isRoute, isLoaded }) {
  const {
    stateData: initialState,
  } = useAppSelector((state) => state[`${reducerPath.logisticTasksBalanceResource}/counter`]);
  const socketLogistic = useAppSelector((state) => state.stateLogisticTasksResource);
  const states = React.useMemo(() => (socketLogistic?.vehicleStates ? {
    ...socketLogistic?.vehicleStates,
  } : {
    ...(initialState?.stateMap?.vehicleStates || {}),
  }), [initialState, socketLogistic]);

  const activeVehicles = React.useMemo(() => (states
    ? Object.keys(states)?.reduce((acc, key) => {
      if (ids?.includes(+key)) {
        const state = states[key];
        if (isRoute) {
          if (!!isLoaded === !!state?.isLoaded) {
            acc.push(states[key]);
          }
        } else if (state?.isLoaded) {
          acc.push(state);
        }
      }
      return acc;
    }, [])
    : []), [ids, states]);

  const error = activeVehicles.filter((e) => e?.status === "ERROR")?.length;
  const stopped = activeVehicles.filter((e) => e?.status === "STOPPED")?.length;
  const running = activeVehicles.filter((e) => e?.status === "RUNNING")?.length;
  const queue = activeVehicles.filter((e) => e?.status === "QUEUE")?.length;
  const loading = activeVehicles.filter((e) => e?.status === "LOADING")?.length;
  const unLoading = activeVehicles.filter((e) => e?.status === "UNLOADING")?.length;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: "10px" }} className={isRoute ? style.inRoute : null}>
      {!isRoute && !!activeVehicles.length && (
        <TruckIcon sx={{ transform: 'scale(-1, 1)', color: "#47607c" }} />
      )}
      <div className={style.table}>
        <div className={style.tableRow}>
          {error > 0 && <div className={style.tableCell} title="Ошибка">О</div>}
          {stopped > 0 && <div className={style.tableCell} title="Стоп">С</div>}
          {running > 0 && <div className={style.tableCell} title="Движение">Д</div>}
          {queue > 0 && <div className={style.tableCell} title="Очередь">Ч</div>}
          {loading > 0 && <div className={style.tableCell} title="Прием/Погрузка">П</div>}
          {unLoading > 0 && <div className={style.tableCell} title="Разгрузка">Р</div>}
        </div>
        <div className={style.tableRow}>
          {error > 0 && <div className={`${style.tableCell} ${style.errorColor}`} title="Ошибка">{error}</div>}
          {stopped > 0 && (
          <div className={`${style.tableCell} ${style.stoppedColor}`} title="Стоп">
            {stopped}
          </div>
          )}
          {running > 0 && (
          <div className={`${style.tableCell} ${style.runningColor}`} title="Движение">
            {running}
          </div>
          )}
          {queue > 0 && <div className={`${style.tableCell} ${style.waitColor}`} title="Очередь">{queue}</div>}
          {loading > 0 && <div className={`${style.tableCell}`} title="Прием/Погрузка">{loading}</div>}
          {unLoading > 0 && <div className={`${style.tableCell}`} title="Разгрузка">{unLoading}</div>}
        </div>
      </div>
    </div>
  );
}

VehicleStatuses.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.number).isRequired,
  isRoute: PropTypes.bool,
  isLoaded: PropTypes.bool,
};

VehicleStatuses.defaultProps = {
  isRoute: false,
  isLoaded: null,
};

export default VehicleStatuses;
